import { mq, COLOR } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { ROOT_PADDING } from "~/styles/padding";

export const DivBreadcrumbsPadding = styled.div`
  display: grid;
  padding: 0 ${ROOT_PADDING.PC}px ${ROOT_PADDING.PC}px ${ROOT_PADDING.PC}px;

  ${mq.sp} {
    padding: 0 ${ROOT_PADDING.SP}px ${ROOT_PADDING.SP}px ${ROOT_PADDING.SP}px;
  }
`;

export const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;

  ${mq.sp} {
    font-size: 12px;
  }
`;

export const DivTitleItem = styled.div<{ isBefore: boolean }>`
  white-space: normal;

  ${({ isBefore }) =>
    isBefore &&
    `
      &:before {
        content: "/";
        color: ${COLOR.GRAY900.code};
        font-size: 14px;
        margin : 0px 8px;

        ${mq.sp} {
          font-size: 12px;
        }
      }
    `}

  > a {
    font-size: 14px;
    color: ${COLOR.BLUE900.code};
    cursor: pointer;
    ${mq.sp} {
      font-size: 12px;
    }

    :disabled {
      pointer-events: none;
    }

    @media (any-hover: hover) {
      :hover {
        text-decoration: underline;
      }
    }
  }
`;
